import { useEffect, useRef } from 'react';

type ScrollLockSnapshot = {
  bodyOverflow: string;
  bodyTouchAction: string;
  htmlOverflow: string;
};

/**
 * Locks body scrolling while `shouldLock` is true and restores previous styles on cleanup.
 */
export const useBodyScrollLock = (shouldLock: boolean) => {
  const previousStylesRef = useRef<ScrollLockSnapshot | null>(null);

  useEffect(() => {
    if (!shouldLock || typeof document === 'undefined') {
      return;
    }

    const { body, documentElement } = document;
    const snapshot: ScrollLockSnapshot = {
      bodyOverflow: body.style.overflow,
      bodyTouchAction: body.style.touchAction,
      htmlOverflow: documentElement.style.overflow,
    };

    previousStylesRef.current = snapshot;

    body.style.overflow = 'hidden';
    body.style.touchAction = 'none';
    documentElement.style.overflow = 'hidden';

    return () => {
      if (!previousStylesRef.current) {
        return;
      }
      body.style.overflow = previousStylesRef.current.bodyOverflow;
      body.style.touchAction = previousStylesRef.current.bodyTouchAction;
      documentElement.style.overflow = previousStylesRef.current.htmlOverflow;
      previousStylesRef.current = null;
    };
  }, [shouldLock]);
};
